import React from "react";
import { DataTable, Select, TextStyle } from "@shopify/polaris";

import { withErrorBoundary } from "lib/hoc";

const APPROVAL_OPTIONS = [
  { label: "Review All Changes", value: "review" },
  { label: "Accept Selected (Price & Qty Only)", value: "selected" },
  { label: "Accept & Publish All", value: "all" },
];

const AdvanceApprovalTable = ({ userInput, setUserInput, vendorList, setDisable }) => {
  const getVendorName = (vendorId) => {
    const vendor = vendorList.find((v) => v._id === vendorId);
    return <TextStyle>{(vendor && vendor.brandName) || vendorId}</TextStyle>;
  };

  const handleApprovalChange = (value, index) => {
    const updated = [...userInput];
    updated[index] = { ...updated[index], productApproval: value };
    setUserInput(updated);
    setDisable(false);
  };

  const handleRemove = (index) => {
    const updated = userInput.filter((_, i) => i !== index);
    setUserInput(updated);
    setDisable(false);
  };

  const getRows = () => {
    if (!userInput || !userInput.length) {
      return [];
    }
    return userInput.map((item, index) => [
      getVendorName(item.vendorId),
      <Select
        key={`approval-${index}`}
        options={APPROVAL_OPTIONS}
        value={item.productApproval || "selected"}
        onChange={(value) => handleApprovalChange(value, index)}
        placeholder=""
      />,
      <span
        key={`remove-${index}`}
        role="button"
        tabIndex={0}
        style={{ cursor: "pointer", color: "#bf0711" }}
        onClick={() => handleRemove(index)}
        onKeyPress={() => handleRemove(index)}
      >
        Remove
      </span>,
    ]);
  };

  return (
    <DataTable
      columnContentTypes={["text", "text", "text"]}
      headings={["Vendor", "Product Approval", ""]}
      rows={getRows()}
    />
  );
};

export default withErrorBoundary(AdvanceApprovalTable);
